var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconArrowUpward48Line = function SvgIconArrowUpward48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.24 21.53 26.11 10.9a2.89 2.89 0 0 0-3.243-.665c-.36.155-.687.381-.958.665L11.78 21.53l2.46 2.35 8.07-8.47V37.7h3.4V15.41l8.07 8.47 2.46-2.35Z",
    fill: "current"
  })));
};
export default SvgIconArrowUpward48Line;